export default {
    detailModule: {
        deadline: 'Application deadline',
        location: 'Location',
        employmentType: 'Employment type',
        languageRequirements: 'Language requirements',
        workPermitRequirements: 'Work permit requirements',
        preferredEducationField: 'Preferred education field',
        preferredEducationLevel: 'Preferred education level',
        jobTags: 'Tags',
        apply: 'Apply now',
        verificationRequired: 'You need to verify your school e-mail to apply.',
        verificationRequiredHint:
            'You need to verify your school e-mail to apply',
        verificationPending: 'You have a pending verification at this school',
        verificationPendingHint:
            'You have a pending verification at this school',
    },
    invalidJobAd: {
        caption:
            "Sorry, but we couldn't find this position. If you believe this is an error, please contact support using the chatbox below.",
        btn: 'Find other jobs',
    },
};
